export const PLUSTAB_HEADER = 'plustab-header'
export const PLUSTAB_SUBHEADER = 'plustab-subheader'

export const CITATIONS_TAB = 'citations-tab'
export const PLAGIARISM_TAB = 'plagiarism-tab'
export const EXPERT_CHECK_TAB = 'expert-check-tab'
export const GRAMMAR_TAB = 'grammar-tab'
